<template>
  <div id="userdetail-page" class="mb-5">
    <b-card>
      <b-row>
        <b-col md="12">
          <h3>{{ $route.name }}</h3>
          <b-breadcrumb>
            <b-breadcrumb-item
              ><router-link to="/dashboard">Dashboard</router-link></b-breadcrumb-item
            >
            <b-breadcrumb-item
              ><router-link to="/sales/quotation">Quotation</router-link></b-breadcrumb-item
            >
            <b-breadcrumb-item active>{{ $route.name }}</b-breadcrumb-item>
          </b-breadcrumb>
          <div class="border-bottom"></div>
        </b-col>
      </b-row>
      <form v-on:submit.prevent="doSubmit()" class="mt-3">
        <div>
          <b-row>
            <b-col md="5 mb-1">
              <label class="labels">No. Quotation</label>
              <div class="form-group w-50 d-flex">
                <input
                  type="number"
                  class="form-control"
                  v-model="model.quotationId"
                  placeholder="No. Quotation"
                />
                <!-- <span class="text-secondary text-bold mt-1 ml-1">
                  {{
                    '/' + 'MKT' + '/' + 'QT' + '/' + romanize(getMonth()) + '/' + getFullYear()
                  }}</span
                > -->
              </div>
            </b-col>

            <b-col md="2"> </b-col>
            <b-col md="5 mb-1">
              <label class="labels">PIC *</label>
              <div class="form-group" v-bind:class="errors.has('pic') ? 'has-error' : ''">
                <input
                  type="text"
                  class="form-control"
                  v-bind:class="errors.has('pic') ? 'is-invalid' : ''"
                  v-validate="'required'"
                  data-vv-as="pic"
                  name="pic"
                  v-model="model.quotationPIC"
                  placeholder="PIC Name"
                />
                <p v-if="errors.has('pic') !== null"></p>
              </div>
              <!-- <label class="labels">valid till </label>
              <div class="form-group" v-bind:class="errors.has('dueDate') ? 'has-error' : ''">
                <b-form-datepicker
                  type="date"
                  :min="min"
                  class="form-control"
                  v-bind:class="errors.has('dueDate') ? 'is-invalid' : ''"
                  data-vv-as="dueDate"
                  name="dueDate"
                  v-model="model.dueDate"
                  placeholder="Valid Till"
                />
                <p v-if="errors.has('dueDate') !== null"></p>
              </div> -->
            </b-col>
          </b-row>
          <b-row>
            <b-col md="5 mb-1">
              <label class="labels">Subject *</label>
              <div class="form-group" v-bind:class="errors.has('subject') ? 'has-error' : ''">
                <input
                  type="text"
                  class="form-control"
                  v-bind:class="errors.has('subject') ? 'is-invalid' : ''"
                  v-validate="'required'"
                  data-vv-as="subject"
                  name="subject"
                  v-model="model.referenceTitle"
                  placeholder="Enter Subject"
                />
                <p v-if="errors.has('subject') !== null"></p>
              </div>
            </b-col>
            <b-col md="2"> </b-col>
            <b-col md="5 mb-1">
              <label class="labels">Quotation to *</label>
              <v-select
                id="mySelect"
                label="text"
                v-model="model.customer"
                :options="customerList"
                :reduce="(text) => text.value"
                class="style-chooser"
                placeholder="search customer..."
              >
                <template #search="{attributes, events}">
                  <input
                    class="vs__search"
                    :required="!model.customer"
                    v-bind="attributes"
                    v-on="events"
                  />
                </template>
              </v-select>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="5 mb-1">
              <label class="labels">Date from *</label>
              <div class="form-group" v-bind:class="errors.has('quotationDate') ? 'has-error' : ''">
                <b-form-datepicker
                  type="date"
                  class="form-control"
                  v-bind:class="errors.has('quotationDate') ? 'is-invalid' : ''"
                  data-vv-as="quotationDate"
                  name="quotationDate"
                  v-model="model.quotationDate"
                  placeholder="Date"
                />
                <p v-if="errors.has('quotationDate') !== null"></p>
              </div>
            </b-col>
            <b-col md="2"></b-col>
            <b-col md="5 mb-1"> </b-col>
          </b-row>
          <b-row>
            <b-col class="mt-3">
              <div class="table-responsive">
                <table>
                  <thead>
                    <tr class="small-text border-bottom">
                      <th width="60">No</th>
                      <th width="400">Item *</th>
                      <th class="text-center" width="160">Quantity *</th>
                      <th v-if="customerValue == 'Personal'" class="text-center" width="200">
                        Normal Price
                      </th>
                      <th v-if="customerValue == 'Corporate'" class="text-center" width="200">
                        Corporate Price *
                      </th>
                      <th class="text-center" width="180">Price</th>
                      <th class="text-center" width="180">Unit</th>
                      <th class="text-center" width="140">Discount (%)</th>
                      <th class="text-center" width="250">Amount</th>
                      <th class="text-center" width="150"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(selectedItem, index) in selectedItems" :key="selectedItem.uuid">
                      <!-- no -->
                      <td>
                        <b-form-input
                          class=" mt-3 small-text selected bg-white"
                          :value="index + 1"
                          readonly
                        >
                        </b-form-input>
                      </td>
                      <!-- item -->
                      <td width="400">
                        <b-textarea
                          style="white-space: pre-line;"
                          v-model="selectedItem.name"
                          :plaintext="!selectedItem.isCustomItem"
                          required
                          class="mt-3 selected small-text"
                          placeholder="Enter Item"
                        />
                      </td>
                      <!-- quantity -->
                      <td>
                        <b-form-input
                          v-model="selectedItem.orderQuantity"
                          type="number"
                          required
                          class="mt-3 text-center selected small-text"
                          style="margin-top:15px!important;"
                          placeholder="Enter Quantity"
                        />
                      </td>
                      <!-- unit price -->
                      <td v-if="customerValue == 'Personal'">
                        <b-form-input
                          v-model="selectedItem.normalPrice"
                          :plaintext="!selectedItem.isCustomItem"
                          type="number"
                          class="mt-3 text-center selected small-text"
                          placeholder="Enter Unit Price"
                        />
                      </td>
                      <td v-if="customerValue == 'Corporate'">
                        <b-form-input
                          v-model="selectedItem.corporatePrice"
                          :plaintext="!selectedItem.isCustomItem"
                          type="number"
                          class="mt-3 text-center selected small-text"
                          placeholder="Enter Unit Price"
                        />
                      </td>
                      <td width="180">
                        <!-- <my-currency-input
                          v-model="selectedItem.price"
                          :plaintext="!selectedItem.isCustomItem"
                          class="mt-3 selected small-text"
                          placeholder="Edit Price"
                        ></my-currency-input> -->
                        <b-form-input
                          v-model="selectedItem.price"
                          :plaintext="!selectedItem.isCustomItem"
                          type="number"
                          class="mt-3 text-center selected small-text"
                          style="margin-top:15px!important;"
                          placeholder="Edit Price"
                        />
                      </td>
                      <!-- discount -->
                      <td>
                        <b-form-input
                          v-model="selectedItem.unit"
                          :plaintext="!selectedItem.isCustomItem"
                          type="text"
                          class="mt-3 text-center selected small-text"
                          style="margin-top:15px!important;"
                          placeholder="enter unit"
                        />
                      </td>
                      <td>
                        <b-form-input
                          v-model="selectedItem.discount"
                          type="number"
                          value="0"
                          min="0"
                          max="70"
                          class="mt-3 text-center selected small-text"
                          style="margin-top:15px!important;"
                          placeholder="Discount in %"
                        />
                      </td>
                      <!-- amount -->
                      <td v-if="customerValue == 'Personal'">
                        <b-form-input
                          :value="selectedItem.orderQuantity * selectedItem.normalPrice"
                          plaintext
                          type="number"
                          class="mt-3 text-center selected small-text"
                        />
                      </td>
                      <td v-if="customerValue == 'Corporate'">
                        <b-form-input
                          :value="selectedItem.orderQuantity * selectedItem.corporatePrice"
                          plaintext
                          type="number"
                          class="mt-3 text-center selected small-text"
                        />
                      </td> 
                      <td class="text-center p-0">
                        <b-button
                          pill
                          v-b-tooltip.hover.right
                          title="Delete Row"
                          style="margin-bottom:5px!important;font-weight:bold!important;padding-top:0px!important; padding-bottom:0px!important;"
                          size="sm"
                          variant="danger"
                          @click="deleteSelectedItem(index)"
                        >
                          x
                        </b-button>
                      </td>
                      <td></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </b-col>
          </b-row>
          <b-row>
              <b-col md="6">
                <b-dropdown text="Add Item" variant="dark">
                  <div
                    style="overflow: scroll; height: 250px; width:489px; border-bottom: 1px solid black"
                  >
                    <v-select
                      multiple
                      v-model="selectedItems"
                      style="width: 100%;"
                      id="mySelect"
                      label="name"
                      @input="addToSelected(availableItem.uuid)"
                      :options="availableItems"
                      :reduce="(uuid) => uuid"
                      class="style-chooser mt-1"
                      placeholder="Type to search Items"
                    ></v-select>
                    
                    <b-dropdown-divider></b-dropdown-divider>
                  </div>
                </b-dropdown>
                <br><br>
                <b-link
                  class="text-bold mt-5"
                  variant="primary"
                  @click="createCustomItem()"
                >
                  Enter Manually
                </b-link>
              </b-col>

               <!-- ===================================================================================
                
                CALCULATOR JCK
              
             ================================================================================== -->

            <b-col md="6">
              <b-card no-body>
                <b-tabs content-class="mt-3" lazy card>
                  <b-tab title="Calc Price" active>
                    <b-row>
                      <b-col md="3 mt-1">
                        <p id="value" class="value-row"><b>Sub Total:</b></p>
                        <hr class="hr-tax" width="217%" style="margin-bottom: 0px!important;" />
                      </b-col>
                      <b-col md="9" v-if="customerValue === 'Personal'">
                        <p id="value" class="tax-value">
                          <b
                            >{{ this.currency === 'Rp' ? 'Rp' : 'RM' }}
                            {{ formatPrice(getSubtotalPersonal()) }}</b
                          >
                        </p>
                      </b-col>
                      <b-col md="3" v-if="customerValue === 'Corporate'">
                        <p id="value" class="tax-value">
                          <b
                            >{{ this.currency === 'Rp' ? 'Rp' : 'RM' }}
                            {{ formatPrice(getSubtotalCorporate()) }}</b
                          >
                        </p>
                      </b-col>
                    </b-row>
                    <!-- ===== batass cuyy ======-->
                    <b-row>
                      <b-col md="3 mt-1">
                        <p id="value" class="value-row"><b>Disc Total:</b></p>
                        <hr class="hr-tax" width="217%" style="margin-bottom: 0px!important;" />
                      </b-col>
                      <b-col md="9" v-if="customerValue === 'Personal'">
                        <p id="value" class="tax-value">
                          <b
                            >{{ this.currency === 'Rp' ? 'Rp' : 'RM' }}
                            {{ formatPrice(getDiscTotalPersonal()) }}</b
                          >
                        </p>
                      </b-col>
                      <b-col md="9" v-if="customerValue === 'Corporate'">
                        <p id="value" class="tax-value">
                          <b
                            >{{ this.currency === 'Rp' ? 'Rp' : 'RM' }}
                            {{ formatPrice(getDiscTotalCorporate()) }}</b
                          >
                        </p>
                      </b-col>
                    </b-row>
                    <!-- ====== batas cuyy ========= -->
                    <b-row>
                      <b-col md="3 mt-1">
                        <p id="value" class="value-row"><b>Total:</b></p>
                        <hr class="hr-tax" width="217%" style="margin-bottom: 0px!important;" />
                      </b-col>
                      <b-col md="9" v-if="customerValue === 'Personal'">
                        <p id="value" class="tax-value">
                          <b
                            >{{ this.currency === 'Rp' ? 'Rp' : 'RM' }}
                            {{ formatPrice(getTotalPersonalOrder()) }}</b
                          >
                        </p>
                      </b-col>
                      <b-col md="9" v-if="customerValue === 'Corporate'">
                        <p id="value" class="tax-value">
                          <b
                            >{{ this.currency === 'Rp' ? 'Rp' : 'RM' }}
                            {{ formatPrice(getTotalCorporateOrder()) }}</b
                          >
                        </p>
                      </b-col>
                    </b-row>
                    <!-- ==== batas cuyy ==== -->
                    <b-row>
                      <b-col md="2 mt-3">
                        <p class="tax-values"><b>Tax *:</b></p>
                      </b-col>
                      <b-col md="3">
                        <b-form-select
                          class="form-control float-right tax-list"
                          v-model="model.taxValue"
                          :options="taxList"
                          required
                        >
                        </b-form-select>
                      </b-col>
                      <b-col md="1">
                        <b-button
                          v-b-tooltip.hover.top
                          title="Add Tax"
                          size="sm"
                          id="btn-add"
                          @click="showModalTax()"
                          ><font-awesome-icon icon="plus"
                        /></b-button>
                      </b-col>
                    </b-row>
                    <!-- ==== batas bang ===== -->
                    <b-row>
                      <b-col md="3 mt-1">
                        <p id="value" class="value-row"><b>Total Tax:</b></p>
                        <hr class="hr-tax" width="217%" style="margin-bottom: 0px!important;" />
                      </b-col>
                      <b-col md="9" v-if="customerValue === 'Personal'">
                        <p
                          id="value"
                          class="tax-value"
                          style="font-size:12px!important; margin-top:12px!important;"
                        >
                          <b
                            >+ ({{ this.currency === 'Rp' ? 'Rp' : 'RM' }}
                            {{ formatPrice(getTaxValuesPersonal()) }})</b
                          >
                        </p>
                      </b-col>
                      <b-col md="9" v-if="customerValue === 'Corporate'">
                        <p
                          id="value"
                          class="tax-value"
                          style="font-size:12px!important; margin-top:12px!important;"
                        >
                          <b
                            >+ ({{ this.currency === 'Rp' ? 'Rp' : 'RM' }}
                            {{ formatPrice(getTaxValuesCorporate()) }})</b
                          >
                        </p>
                      </b-col>
                    </b-row>
                    <!-- ========== batass ============ -->
                    <b-row>
                      <b-col md="3 mt-1">
                        <p id="value" class="value-row" style="font-size:18px!important;">
                          <b class="text-primary text-bold">Grant Total:</b>
                        </p>
                        <hr class="hr-tax" width="227%" style="margin-bottom: 0px!important;" />
                      </b-col>
                      <b-col md="9">
                        <span
                          id="value"
                          v-if="customerValue === 'Personal'"
                          class="tax-value mt-2"
                          style="font-size:18px!important;"
                        >
                          <h5 class="text-bold mt-2">
                            {{ this.currency === 'Rp' ? 'Rp' : 'RM' }}
                            {{ formatPrice(getTotalPersonal()) }}
                          </h5>
                        </span>
                        <span
                          id="value"
                          v-if="customerValue === 'Corporate'"
                          class="tax-value mt-2"
                          style="font-size:18px!important;"
                        >
                          <h5 class="text-bold mt-2">
                            {{ this.currency === 'Rp' ? 'Rp' : 'RM' }}
                            {{ formatPrice(getTotalCorporate()) }}
                          </h5>
                        </span>
                      </b-col>
                    </b-row>
                  </b-tab>
                  <b-tab title="Calc edit price">
                    <b-row>
                      <b-col md="2 mt-1">
                        <p id="value" class="value-row"><b>Sub Total:</b></p>
                        <hr class="hr-tax" width="217%" style="margin-bottom: 0px!important;" />
                      </b-col>
                      <b-col md="3">
                        <p id="value" class="float-right tax-value">
                          <b
                            >{{ this.currency === 'Rp' ? 'Rp' : 'RM' }}
                            {{ formatPrice(getSubtotalCustom()) }}</b
                          >
                        </p>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col md="2 mt-1">
                        <p id="value" class="value-row"><b>Disc Total:</b></p>
                        <hr class="hr-tax" width="217%" style="margin-bottom: 0px!important;" />
                      </b-col>
                      <b-col md="3">
                        <p id="value" class="float-right tax-value">
                          <b
                            >{{ this.currency === 'Rp' ? 'Rp' : 'RM' }}
                            {{ formatPrice(getDiscTotalCustom()) }}</b
                          >
                        </p>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col md="2 mt-1">
                        <p id="value" class="value-row"><b>Total:</b></p>
                        <hr class="hr-tax" width="217%" style="margin-bottom: 0px!important;" />
                      </b-col>
                      <b-col md="3">
                        <p id="value" class="float-right tax-value">
                          <b
                            >{{ this.currency === 'Rp' ? 'Rp' : 'RM' }}
                            {{ formatPrice(getTotalCustomOrder()) }}</b
                          >
                        </p>
                      </b-col>
                    </b-row>
                     <!-- ==== batas cuyy ==== -->
                    <b-row>
                      <b-col md="2 mt-3">
                        <p class="tax-values"><b>Tax *:</b></p>
                      </b-col>
                      <b-col md="3">
                        <b-form-select
                          class="form-control float-right tax-list"
                          v-model="model.taxValue"
                          :options="taxList"
                          required
                        >
                        </b-form-select>
                      </b-col>
                      <b-col md="1">
                        <b-button
                          v-b-tooltip.hover.top
                          title="Add Tax"
                          size="sm"
                          id="btn-add"
                          @click="showModalTax()"
                          ><font-awesome-icon icon="plus"
                        /></b-button>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col md="2 mt-1">
                        <p id="value" class="value-row"><b>Total Tax:</b></p>
                        <hr class="hr-tax" width="217%" style="margin-bottom: 0px!important;" />
                      </b-col>
                      <b-col md="3">
                        <p
                          id="value"
                          class="float-right tax-value"
                          style="font-size:12px!important; margin-top:12px!important;"
                        >
                          <b
                            >+ ({{ this.currency === 'Rp' ? 'Rp' : 'RM' }}
                            {{ formatPrice(getTaxValuesCustom()) }})</b
                          >
                        </p>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col md="3 mt-1">
                        <p id="value" class="value-row" style="font-size:18px!important;">
                          <b class="text-primary text-bold">Grant Total:</b>
                        </p>
                        <hr class="hr-tax" width="227%" style="margin-bottom: 0px!important;" />
                      </b-col>
                      <b-col md="4">
                        <span
                          id="value"
                          class="float-right tax-value"
                          style="font-size:18px!important;"
                        >
                          <h5 class="text-bold">
                            {{ this.currency === 'Rp' ? 'Rp' : 'RM' }}
                            {{ formatPrice(getTotalCustom()) }}
                          </h5>
                        </span>
                      </b-col>
                    </b-row>
                  </b-tab>
                </b-tabs>
              </b-card>
            </b-col>

            <!-- ====================  end CALC JCK ======================================== -->
           
          </b-row>
          <b-row>
            <b-col md="6">
              <label class="labels">Note </label>
              <textarea class="form-control h-100" v-model="model.note" placeholder="Enter something..." />
            </b-col>
          </b-row>
          <b-card class="mt-5 mb-4 bordered-card" bg-variant="light">
            <b-row>
              <!-- <b-col md="3"> </b-col> -->
              <b-col md="5">
                <b-card class="border-none">
                  <label class="labels">Term and Conditions </label>
                  <wysiwyg
                    v-model="model.termCondition"
                    placeholder="Enter term and conditions..."
                  />
                  <!-- <b-form-textarea rows="15" v-model="model.termConditions" style="font-size:12px!important;text-align:justify;">
                  </b-form-textarea> -->
                </b-card>
              </b-col>
              <b-col md="3"> </b-col>
              <b-col md="4" class="mt-3">
                <label class="labels">Approved By *</label>
                <b-form-select
                  name="employee"
                  required
                  v-model="model.signedBy"
                  :options="employeeList"
                >
                </b-form-select>
                <b-form-checkbox
                  id="checkbox-1"
                  v-model="model.isSigned"
                  name="checkbox-1"
                  value="1"
                  unchecked-value="0"
                  class="mt-2"
                >
                  Signature
                </b-form-checkbox>
                <b-form-checkbox
                  id="checkbox-2"
                  v-model="model.isStamp"
                  name="checkbox-2"
                  value="1"
                  unchecked-value="0"
                  class="mt-2"
                >
                  Stamp
                </b-form-checkbox>
              </b-col>
            </b-row>
          </b-card>
          <b-row class="mt-3">
            <b-col md="12">
              <b-button class="mr-2" @click="goBack" variant="secondary"
                ><font-awesome-icon icon="chevron-circle-left"></font-awesome-icon> Back</b-button
              >
              <b-button variant="primary" :disabled="!disable" class="btn-back float-right" type="submit"
                ><font-awesome-icon icon="save"></font-awesome-icon> Submit</b-button
              >
            </b-col>
          </b-row>
        </div>
        <b-modal id="bv-modal-tax" hide-footer>
          <template v-slot:modal-title>
            <h5 class="text-transform">Add Tax</h5>
          </template>
          <div>
            <form v-on:submit.prevent="doAddTax()">
              <div class="d-block">
                <b-form-input
                  v-model="formData.name"
                  required
                  placeholder="Enter Name"
                ></b-form-input
                ><br />
                <b-form-input
                  type="number"
                  v-model="formData.value"
                  required
                  placeholder="Enter Value"
                ></b-form-input>
                  <br>
                  <label for=""><strong>Journal Account*</strong></label>
                  <v-select
                    id="mySelect"
                    label="text"
                    v-model="formData.journalAccount"
                    :options="journalAccountList"
                    :reduce="(text) => text.value"
                    class="style-chooser"
                    placeholder="search journal account..."
                  >
                    <template #search="{attributes, events}">
                      <input
                        class="vs__search"
                        :required="!formData.journalAccount"
                        v-bind="attributes"
                        v-on="events"
                      />
                    </template>
                  </v-select>
                <!-- <b-button class="mt-4" @click="$bvModal.hide('bv-modal-tax')"
            >
              ><font-awesome-icon icon="times"></font-awesome-icon> Cancel</b-button> -->
                <b-button variant="success" class="btn btn-sm mt-3 mb-3 float-right" type="submit"
                  ><font-awesome-icon icon="plus"></font-awesome-icon> Add</b-button
                >
                <b-table
                  :fields="fields"
                  :items="tax"
                  responsive="sm"
                  class="align-items-center mt-3 text-center"
                >
                  <template #cell(name)="row">
                    <p class="align-items-center my-auto font-weight-bold">{{ row.item.name }}</p>
                  </template>

                  <template #cell(actions)="row">
                    <!-- <a
                    v-if="canDelete"
                    v-on:click="deleteTax(row)"
                    v-b-tooltip.hover.left
                    title="Delete"
                    class="btn-op icon-delete mr-2"
                  ></a>
                  <a
                    v-else
                    v-on:click="deleteTax()"
                    v-b-tooltip.hover.left
                    title="Delete"
                    class="btn-op icon-delete mr-2"
                  ></a> -->

                    <a
                      v-if="canEdit"
                      v-on:click="showModalEditTax(row)"
                      v-b-tooltip.hover.right
                      title="Edit"
                      class="btn-op icon-edit mr-1"
                    ></a>
                    <a
                      v-else
                      v-on:click="showModalEditTax(row)"
                      v-b-tooltip.hover.right
                      title="Edit"
                      class="btn-op icon-edit mr-1"
                    ></a>
                  </template>
                </b-table>
              </div>
            </form>
          </div>
        </b-modal>
        <b-modal id="bv-modal-tax-edit" hide-footer>
          <template v-slot:modal-title>
            <h5 class="text-transform">Edit Tax</h5>
          </template>
          <form v-on:submit.prevent="doEditTax()">
            <div class="d-block">
              <label for=""><strong>Name *</strong></label>
              <b-form-input v-model="formData.name" required placeholder="Enter Name"></b-form-input
              ><br />
              <label for=""><strong>Value *</strong></label>
              <b-form-input
                type="number"
                v-model="formData.value"
                required
                placeholder="Enter Value"
              ></b-form-input>
              <br>
              <label for=""><strong>Journal Account*</strong></label>
              <v-select
                id="mySelect"
                label="text"
                v-model="formData.journalAccount"
                :options="journalAccountList"
                :reduce="(text) => text.value"
                class="style-chooser"
                placeholder="search customer..."
              >
                <template #search="{attributes, events}">
                  <input
                    class="vs__search"
                    :required="!formData.journalAccount"
                    v-bind="attributes"
                    v-on="events"
                  />
                </template>
              </v-select>
            </div>
            <b-button class="mt-4" @click="$bvModal.hide('bv-modal-tax-edit')"
              ><font-awesome-icon icon="times"></font-awesome-icon> Cancel</b-button
            >
            <b-button variant="warning" type="submit" class="mt-4 float-right"
              ><font-awesome-icon icon="save"></font-awesome-icon>
              <b-spinner type="grow" v-if="loadingButton" label="Spinning"></b-spinner>
              Update</b-button
            >
          </form>
        </b-modal>
      </form>
    </b-card>
  </div>
</template>

<script>
import wysiwyg from 'vue-wysiwyg';
import Vue from 'vue';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
Vue.use(vSelect, 'v-select');
Vue.use(wysiwyg, {
  hideModules: {
    headings: true,
    code: true,
    link: true,
    image: true,
    table: true,
    unorderedList: true,
    separator: true,
  },
}); // config is optional. more below

export default {
  components: {},
  name: 'customer-form',
  data: function() {
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const minDate = new Date(today);
    minDate.setDate(minDate.getDate() - 0);

    return {
      loadingButton: false,
      searchShow: false,
      isLoading: false,
      isCustomItem: false,
      isDeleted: false,
      value: '',
      min: minDate,
      itemsList: [],
      apiUrl: {
        quotation: window.AppConfig.apiUrl + 'quotation',
        customer: window.AppConfig.apiUrl + 'customer',
        itemList: window.AppConfig.apiUrl + 'item-list',
        // profile: window.AppConfig.apiUrl + 'profile?active=1'
      },
      dataItem: [],
      selectedItems: [],
      // price of selected item.
      itemPrice: 0,
      // array of find
      tax: [],
      // single item from database
      fields: [
        {
          key: 'name',
          label: 'Tax Name',
        },
        {
          key: 'value',
          label: 'Value',
        },
        {
          key: 'journalAccount.journalAccountName',
          label: 'Journal account'
        },
        {
          key: 'actions',
          label: '',
        },
      ],
      canDelete: {
        type: Boolean,
        required: false,
        default: true,
      },
      canEdit: {
        type: Boolean,
        required: false,
        default: true,
      },
      customerValue: '',
      availableItems: [],
      selectedItem: {},
      company: '',
      companyUuid: '',
      branch: '',
      branchUuid: '',
      taxesValue: '',
      currency: '',
      totalSubtotal: 0,
      totalTaxValue: 0,
      model: {
        isSigned: 1,
        isStamp: 1,
        customer: null,
        signedBy: null,
        quotationId: '',
        referenceTitle: '',
        quotationPIC: '',
        tax: '',
        taxValue: null,
        dueDate: '',
        quotationDate: null,
        termConditions: null,
        status: null,
        quotationItem: [],
        note: '',
        normalPrice: '',
        corporatePrice: '',
        termCondition:
          '\n1. All prices quoted are valid for 30 days from the date of stated on the quotation. <br>\n2. Payment will be billed after indicating acceptance of this quote. <br> \n3. Service and and goods will be delivered after receiving 30% down payment .',
      },
      modelValidations: {
        // taxValue: {
        //   required: true
        // }
      },
      formData: {
        name: null,
        value: null,
        note: '',
        uuid: null,
        journalAccount: null
      },
      // tableFilter: {
      //   item_name: this.$route.query.name,
      //   name: {
      //     value: null,
      //   },
      // },
      taxList: [],
      taxListTable: [],
      customerList: [],
      profileList: [],
      employeeList: [],
      customerSales: null,
      uuidTax: '',
      journalAccountList: []
    };
  },
   computed: {
    disable() {
      if (this.selectedItems.length !== 0) {
        return true;
      }
      return false;
    },
  },
  watch: {
    // 'fakeTableFilter.name'(value) {
    //   this.tableFilter.name = value ? 1 : null;
    //   this.doFilter();
    // },
    'model.customer'(value) {
      this.getCustomerByValue(value);
      // console.log(value);
    },

    'model.taxValue'(value) {
      this.getTaxByValue(value);
    },

    'tableFilter.name'() {
      this.doFilter();
    },

    // 'taxList.uuid'(value) {
    //   this.getTaxValue(value);
    // },

    // 'formData.uuid'(value){
    //   this.showModalEditTax(value);
    //   console.log('uuid ?',value);
    // }
  },
  methods: {
    /*
     * get detail of quotation data from database quotation
     */
    initData() {
      if (this.$route.params.uuid !== undefined) {
        this.getDetail();
      }
    },
    getDetail() {
      this.isLoading = true;
      this.$http
        .get(this.apiUrl.quotation + '/' + this.$route.params.uuid)
        .then((response) => {
          this.model.customer = response.data.customer.uuid;
          this.model.referenceTitle = response.data.referenceTitle;
          this.model.orderType = response.data.orderType;
          this.model.taxValue =
            response.data.taxValue !== null ? response.data.taxValue.uuid : null;
          this.model.dueDate =
            response.data.dueDate !== null
              ? this.$moment(response.data.dueDate).format('YYYY-MM-DD')
              : null;
        })
        .catch((error) => {
          this.isLoading = false;
          this.$store.dispatch('notification/error', error);
        });
    },

    showSearch() {
      this.searchShow = !this.searchShow;
    },

    /*
     * post quotation data to quotation database
     */
    doSubmit() {
      const toSubmit = this.selectedItems.map((selectedItem) => ({
        uuid: '',
        itemList: selectedItem.uuid !==null && selectedItem.uuid !== "" ? selectedItem.uuid : "",
        quantity: selectedItem.orderQuantity,
        discount: selectedItem.discount,
        customItem: selectedItem.name,
        customPrice: selectedItem.price > 0 ? selectedItem.price : 0,
        customUnit: selectedItem.unit !=="" && selectedItem.unit !==null ? selectedItem.unit : "-",
        delete: '0',
        // taxValue: selectedItem.taxValue.value ? "" : selectedItem.taxValue.value
      }));
      if (this.selectedItem.uuid === null) {
        this.$store.dispatch('notification/error', 'Masukkan item');
      }
      this.$validator.validateAll().then((res) => {
        if (res) {
          let formData = new FormData();
          formData.append('quotationId', this.model.quotationId);
          formData.append('referenceTitle', this.model.referenceTitle);
          formData.append('quotationPIC', this.model.quotationPIC);
          formData.append('dueDate', this.model.dueDate);
          formData.append('quotationDate', this.model.quotationDate);
          formData.append('customer', this.model.customer);
          formData.append('note', this.model.note);
          formData.append('isSigned', this.model.isSigned);
          formData.append('isStamp', this.model.isStamp);
          formData.append('taxValue', this.model.taxValue);
          formData.append('signedBy', this.model.signedBy);
          formData.append('termCondition', this.model.termCondition);
          formData.append('quotationItem', JSON.stringify(toSubmit));
          this.$http
            .post(this.apiUrl.quotation, formData)
            .then((response) => {
              this.$store.dispatch('notification/success', 'Quotation has been added.');
              window.location.href = document.URL.replace('/create', '/' + response.data.uuid);
            })
            .catch((error) => {
              this.$store.dispatch('notification/error', error);
            });
        } else {
          swal('', 'Please fill the required fields!', 'info', {
            buttons: false,
            timer: 2000,
          });
        }
      });
    },

    getEmployee() {
      this.$http
        .get(window.AppConfig.apiUrl + 'profile?role=admin')
        .then((response) => {
          this.employeeList = [
            {
              value: null,
              text: 'Select Name',
            },
          ];
          response.data._embedded.profile.forEach((data) => {
            let names = data.firstName + '\xa0' + data.lastName;
            this.fullName = names;
            this.employeeList.push({
              value: data.uuid,
              text: this.fullName,
            });
          });
        })
        .catch((error) => {
          window.consoleLog(error);
        });
    },

    // doSubmit () {
    //   const toSubmit = this.selectedItems.map(selectedItem => ({
    //     uuid: "",
    //     item: selectedItem.isCustomItem ? "" : selectedItem.uuid,
    //     qtyIssue: "0",
    //     qtyUsed: selectedItem.orderQuantity,
    //     customItem: selectedItem.isCustomItem ? selectedItem.name : "",
    //     customPrice: selectedItem.isCustomItem ? selectedItem.normalPrice : "",
    //     customPriceCorporate: selectedItem.isCustomItem ? selectedItem.corporatePrice : "",
    //     discount: selectedItem.discount,
    //     delete: "0",
    //   }));

    //   this.$validator.validateAll().then(res => {
    //     if (res) {
    //       let formData = new FormData()
    //       formData.append('quotationId', this.model.quotationId)
    //       formData.append('quotationDate', this.model.quotationDate)
    //       formData.append('dueDate', this.model.dueDate)
    //       formData.append('customer', this.model.customer)
    //       formData.append('quotationItem', JSON.stringify(toSubmit))
    //       formData.append('referenceTitle', this.model.referenceTitle)
    //       formData.append('taxValue', this.model.taxValue)
    //       formData.append('termCondition', this.model.termConditions)
    //       this.$http.post(this.formData).then(response => {
    //         this.$store.dispatch('notification/success', 'Quotation has been added.')
    //         console.log(this.formData);
    //         window.location.href = document.URL.replace('/edit', '/' + response.data.uuid)
    //       }).catch(error => {
    //         this.$store.dispatch('notification/error', error)
    //       })
    //     } else {
    //       swal("", "Please fill the required fields!", "info", {
    //         buttons: false,
    //         timer: 2000
    //       });
    //     }
    //   })
    // },

    /**
     * doFilter
     */

    // doFilter() {
    //   this.tableFilter.customer.name = this.tableFilter.customer;
    // },

    /**
     * format price
     */
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(',', '.');
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },

    /**
     * get data customer from database
     */
    getCustomer() {
      this.$http
        .get(window.AppConfig.apiUrl + 'customer?limit=100')
        .then((response) => {
          this.customerList = [];
          response.data._embedded.customer.forEach((data) => {
            this.customerSales = data.salesType;
            this.customerList.push({
              value: data.uuid,
              text: data.name,
            }),
              (this.currency = data.account.currency);
          });
        })
        .catch((error) => {
          window.consoleLog(error);
        });
    },

    getCustomerByValue(uuid) {
      this.customerValue = '';
      this.$http
        .get(window.AppConfig.apiUrl + 'customer' + '/' + uuid)
        .then((response) => {
          this.customerValue = response.data.salesType;
          if (this.customerValue === 'Personal') {
            this.getTotalPersonalOrder();
            this.getDiscTotalPersonal();
            this.getSubtotalPersonal();
            this.getTotalPersonal();
          } else {
            this.getTotalCorporateOrder();
            this.getDiscTotalCorporate();
            this.getSubtotalCorporate();
            this.getTotalCorporate();
          }
          console.log('value ny adalah', this.customerValue);
        })
        .catch((error) => {
          window.consoleLog(error);
        });
    },

    /**
     * get tax value from tax category
     */
    getTaxByValue(uuid) {
      let totalTaxValue = 0;
      this.$http
        .get(window.AppConfig.apiUrl + 'tax-value' + '/' + uuid)
        .then((response) => {
          this.taxesValue = response.data.value;
          this.totalTaxValue = (this.taxesValue * this.taxesValue) / 100;
        })
        .catch((error) => {
          window.consoleLog(error);
        });
    },

    /**
     * get data tax category from database
     */
    getTaxValue() {
      this.$http
        .get(window.AppConfig.apiUrl + 'tax-value?limit=100')
        .then((response) => {
          this.taxList = [
            {
              value: null,
              text: 'Select Tax',
            },
          ];
          response.data._embedded.tax_value.forEach((data) => {
            this.taxList.push({
              value: data.uuid,
              text: data.name,
            });
          });
        })
        .catch((error) => {
          window.consoleLog(error);
        });
    },

    /**
     * show modal for input data tax to database
     */
    showModalTax() {
      this.formData.name = null;
      this.formData.value = null;
      this.formData.journalAccount = null;
      this.$bvModal.show('bv-modal-tax');
    },

    /** ini button untuk menampilkan form edit berbentuk modal */
     showModalEditTax(row) {
      this.uuidTax = row.item.uuid;
      if (row !== undefined) {
        this.$bvModal.show('bv-modal-tax-edit');
        this.formData.name = row.item.name;
        this.formData.value = row.item.value;
        this.formData.journalAccount = row.item.journalAccount.journalAccountName
        //  console.log('ini row', this.uuidTax);
      } else {
        console.log('no data rowuuid :');
      }
    },
    /**
     * post data tax to database
     */
    doAddTax() {
      this.isLoading = true;
      this.$http
        .post(window.AppConfig.apiUrl + 'tax-value', {
          name: this.formData.name,
          value: this.formData.value,
          journalAccount: this.formData.journalAccount
        })
        .then((resp) => {
          this.isLoading = false;
          this.formData.name = null;
          this.formData.note = null;
          this.formData.journalAccount = null
          this.getTax();
          this.getTaxValue();
          this.$bvModal.hide('bv-modal-tax-edit');
          this.$store.dispatch('notification/success', 'Tax has been added');
        })
        .catch((error) => {
          this.isLoading = false;
          this.$store.dispatch('notification/error', error);
        });
    },

    doEditTax() {
      this.loadingButton = true;
      this.$http
        .patch(window.AppConfig.apiUrl + 'tax-value' + '/' + this.uuidTax, {
          name: this.formData.name,
          value: this.formData.value,
          journalAccount: this.formData.journalAccount
        })
        .then((resp) => {
          this.loadingButton = false;
          this.formData.name = null;
          this.formData.value = null;
          this.formData.journalAccount = null;
          this.$bvModal.hide('bv-modal-tax-edit');
          this.getTax();
          this.$store.dispatch('notification/success', 'Tax has been update');
        })
        .catch((error) => {
          this.loadingButton = false;
          this.$store.dispatch('notification/error', error);
        });
    },

    getJournal(){
      this.$http.get(window.AppConfig.apiUrl + 'journal-account?journalAccountType=D').then((resp)=>{
        this.journalAccountList = [];
        resp.data._embedded.journal_account.forEach(data =>{
          this.journalAccountList.push({
            value: data.uuid,
            text: data.journalAccountCode + ' - ' + data.journalAccountType + ' - ' + data.journalAccountName
          })
        })
      })
    },

    // getTaxUuid(uuid){
    //   this.$http.get(window.AppConfig.apiUrl + 'tax-value' + '/' + uuid).then(resp => {
    //     this.formData.name = resp.data.name;
    //     this.formData.value = resp.data.value;
    //     console.log('edit ',uuid);
    //   }).catch((error) => {
    //     this.$store.dispatch('notification/error', error);
    //   });
    // },

    getTax() {
      this.$http.get(window.AppConfig.apiUrl + 'tax-value').then((response) => {
        this.tax = [];
        this.taxListTable = [
          {
            value: null,
            text: 'Please Select Tax',
          },
        ];
        response.data._embedded.tax_value.forEach((data) => {
          this.tax = response.data._embedded.tax_value;
          this.taxListTable.push({
            value: data.uuid,
            text: data.name,
          });
        });
      });
    },

    deleteTax(row) {
      this.isLoading = true;
      this.$http
        .delete(window.AppConfig.apiUrl + 'tax-value' + '/' + row.item.uuid)
        .then(() => {
          this.isLoading = false;
          // this.$bvModal.hide('bv-modal-merk')
          this.getTax();
          this.$store.dispatch('notification/success', 'Tax deleted successfull');
        })
        .catch((error) => {
          // this.isLoading = true
          this.$store.dispatch('notification/error', error);
        });
    },

    /**
     * @function fetchAvailableItems
     * @async
     * fetch items for sale from API then remap it
     * by adding OrderQuantity and isManuallyEntered
     */
    fetchAvailableItems: async function() {
      const response = await this.$http.get(window.AppConfig.apiUrl + 'item-list');
      this.dataItem = response.data._embedded.item_list.name;
      this.availableItems = response.data._embedded.item_list.map((availableItem) => ({
        uuid: availableItem.uuid,
        name: availableItem.name,
        normalPrice: availableItem.normalPrice,
        corporatePrice: availableItem.corporatePrice,
        taxValue: availableItem.taxValue,
        unit: availableItem.itemUnit !==null && availableItem.itemUnit !=='' ? availableItem.itemUnit.name : ' ',
        orderQuantity: 0,
        discount: 0,
        price: 0,
        amount: 0,
        isCustomItem: true,
        isDeleted: false,
        // timezone: availableItem.account.currency
      }));
    },

    // getAvailableItems (name) {
    //   if(name.length > 1);
    //   this.$http.get(this.apiUrl.quotation + '?name=').then(response => {
    //    response.data._embedded.quotation.forEach(data => {
    //        this.itemList.push({
    //        value: data.uuid,
    //        text: data.name
    //        })
    //    })
    //    })
    // },

    /**
     * @function addToSelected
     * @param {{ isManuallyEntered, name, orderQuantity, price, discount, uuid }} item
     * add the item object into selectedItems array.
     */
    addToSelected: function(item) {
      this.selectedItems.push(item);
      console.log(this.selectedItems);
    },

    /**
     * @function createCustomItem
     * create an empty input fields to enter items
     * that is currently not in the database.
     */
    createCustomItem: function() {
      this.addToSelected({
        uuid: '',
        name: '',
        price: 0,
        unit: '',
        taxValue: null,
        orderQuantity: 0,
        discount: 0,
        amount: 0,
        isCustomItem: true,
        isDeleted: false,
      });
      console.log(this.selectedItems);
    },

    /**
     * @function deleteSelectedItem
     * @param { Number } index
     * delete an item from the selectedItems array,
     * and from the quotation form.
     */
    deleteSelectedItem: function(index) {
      this.selectedItems.splice(index, 1);
    },

    /**
     * @function getRemainingAvailableItems
     * get availableItems that is not yet added into selectedItems
     * by extracting UUIDs from selectedItems into selectedItemsUUID array
     * then filter out items whose UUID is in the selectedItemsUUID array.
     */
    getRemainingAvailableItems: function() {
      const selectedItemsUUID = this.selectedItems.map(({ uuid }) => uuid);
      return this.availableItems.filter(
        (availableItem) => !selectedItemsUUID.includes(availableItem.uuid),
      );
    },

     /*
     *counting subtotal
     */
    getSubtotalPersonal: function() {
      let subtotal = 0;
      this.selectedItems.forEach(({ orderQuantity, normalPrice }) => {
        subtotal = subtotal + orderQuantity * normalPrice;
      });
      return subtotal;
    },

    getSubtotalCorporate: function() {
      let subtotal = 0;
      this.selectedItems.forEach(({ orderQuantity, corporatePrice }) => {
        subtotal = subtotal + orderQuantity * corporatePrice;
      });
      return subtotal;
    },

    getSubtotalCustom() {
      let subtotal = 0;
      this.selectedItems.forEach(({ orderQuantity, price }) => {
        subtotal = subtotal + orderQuantity * price;
      });
      return subtotal;
    },

    /**
     * counting disctotal
     */
    getDiscTotalPersonal: function() {
      let disctotal = 0;
      this.selectedItems.forEach(({ orderQuantity, normalPrice, discount }) => {
        disctotal = disctotal + (orderQuantity * normalPrice * discount) / 100;
      });
      return disctotal;
    },

    getDiscTotalCorporate: function() {
      let disctotal = 0;
      this.selectedItems.forEach(({ orderQuantity, corporatePrice, discount }) => {
        disctotal = disctotal + (orderQuantity * corporatePrice * discount) / 100;
      });
      return disctotal;
    },

    getDiscTotalCustom() {
      let disctotal = 0;
      this.selectedItems.forEach(({ orderQuantity, price, discount }) => {
        disctotal = disctotal + (orderQuantity * price * discount) / 100;
      });
      return disctotal;
    },

    /*
     * counting total tax
     */
    getTaxValuesPersonal: function() {
      let subtotal = 0;
      let taxValued = 0;
      this.selectedItems.forEach(({ orderQuantity, normalPrice, discount }) => {
        subtotal =
          subtotal + (orderQuantity * normalPrice - (orderQuantity * normalPrice * discount) / 100);
        taxValued = (subtotal * this.taxesValue) / 100;
      });
      return taxValued;
    },

    getTaxValuesCorporate: function() {
      let subtotal = 0;
      let taxValued = 0;
      this.selectedItems.forEach(({ orderQuantity, corporatePrice, discount }) => {
        subtotal =
          subtotal +
          (orderQuantity * corporatePrice - (orderQuantity * corporatePrice * discount) / 100);
        taxValued = (subtotal * this.taxesValue) / 100;
      });
      return taxValued;
    },

    getTaxValuesCustom: function() {
      let subtotal = 0;
      let taxValued = 0;
      this.selectedItems.forEach(({ orderQuantity, price, discount }) => {
        subtotal = subtotal + (orderQuantity * price - (orderQuantity * price * discount) / 100);
        taxValued = (subtotal * this.taxesValue) / 100;
      });
      return taxValued;
    },

    /*
     * counting total price
     */

    getTotalCorporateOrder() {
      let totalOrder = 0;
      this.selectedItems.forEach(({ orderQuantity, corporatePrice, discount }) => {
        totalOrder =
          totalOrder +
          (orderQuantity * corporatePrice - (orderQuantity * corporatePrice * discount) / 100);
      });
      return totalOrder;
    },

    getTotalPersonalOrder() {
      let totalOrder = 0;
      this.selectedItems.forEach(({ orderQuantity, normalPrice, discount }) => {
        totalOrder =
          totalOrder +
          (orderQuantity * normalPrice - (orderQuantity * normalPrice * discount) / 100);
      });
      return totalOrder;
    },

    getTotalCustomOrder() {
      let totalOrder = 0;
      this.selectedItems.forEach(({ orderQuantity, price, discount }) => {
        totalOrder =
          totalOrder + (orderQuantity * price - (orderQuantity * price * discount) / 100);
      });
      return totalOrder;
    },

    /**
     *
     ********************************** counting grant total here ****************************
     */

    getTotalPersonal: function() {
      let subtotal = 0;
      let totalSubtotal = 0;
      this.selectedItems.forEach(({ orderQuantity, normalPrice, discount }) => {
        subtotal =
          subtotal + (orderQuantity * normalPrice - (orderQuantity * normalPrice * discount) / 100);
        totalSubtotal = subtotal + (subtotal * this.taxesValue) / 100;
      });
      return totalSubtotal;
    },

    getTotalCorporate: function() {
      let subtotal = 0;
      let totalSubtotal = 0;
      this.selectedItems.forEach(({ orderQuantity, corporatePrice, discount }) => {
        subtotal =
          subtotal +
          (orderQuantity * corporatePrice - (orderQuantity * corporatePrice * discount) / 100);
        totalSubtotal = subtotal + (subtotal * this.taxesValue) / 100;
      });
      return totalSubtotal;
    },

    getTotalCustom: function() {
      let subtotal = 0;
      let totalSubtotal = 0;
      this.selectedItems.forEach(({ orderQuantity, price, discount }) => {
        subtotal = subtotal + (orderQuantity * price - (orderQuantity * price * discount) / 100);
        totalSubtotal = subtotal + (subtotal * this.taxesValue) / 100;
      });
      return totalSubtotal;
    },

    /************************************************************************************ */

    goBack() {
      window.goBack(this);
    },

    getMonth(value) {
      if (value !== null) {
        return this.$moment(value).format('MM');
      } else {
        return '-';
      }
    },

    getFullYear(value) {
      if (value !== null) {
        return this.$moment(value).format('YYYY');
      } else {
        return '-';
      }
    },

    romanize(num) {
      var lookup = {
          M: 1000,
          CM: 900,
          D: 500,
          CD: 400,
          C: 100,
          XC: 90,
          L: 50,
          XL: 40,
          X: 10,
          IX: 9,
          V: 5,
          IV: 4,
          I: 1,
        },
        roman = '',
        i;
      for (i in lookup) {
        while (num >= lookup[i]) {
          roman += i;
          num -= lookup[i];
        }
      }
      return roman;
    },
  },

  mounted: function() {
    this.fetchAvailableItems();
    this.getCustomer();
    this.getTaxValue();
    this.initData();
    this.getTax();
    // this.getCustomerName();
    this.getEmployee();
    this.getFullYear();
    this.getMonth();
    this.getJournal();
    this.romanize();
    // this.getTaxUuid();
    // this.getAvailableItems();
  },
};
</script>
<style>
@import '~vue-wysiwyg/dist/vueWysiwyg.css';
#mySelect .v-select .dropdown-toggle ::placeholder {
  border: none;
  color: #d3d3d3 !important;
}
</style>
